import React from "react";
import { Card } from "react-bootstrap";
import "./UserLandingPage.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import classess from "./UserLandingPage.module.css";

const UserLandingPageCard = ({
  title,
  titleIcon,
  value,
  viewText,
  quantity,
  removedText,
  addedText,
  barIcon,
  onClickHander,
}) => {
  return (
    <>
      <div
        className={` mt-2  ${classess.userLandingPageCard}`}
        onClick={onClickHander}
      >
        <div className="p-2">
          <div className="d-flex justify-content-between w-100 ">
            <div className="w-100">
              <div className="d-flex text-muted   align-items-center">
                <img src={titleIcon} alt="logo" width={60} height={60} />
                <div className="fw-bold fs-6 text-dark mx-4 ">
                  <div className="">{value}</div>
                  <div className="">{title}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserLandingPageCard;
